import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

function Menu() {
    return (
        <MenuWrapper>
            <ul>
                <ListItems to='/'  ><li className='clickable' ></li></ListItems>
                <ListItems to='/about'  ><li className='clickable' ></li></ListItems>
                <ListItems to='/projects'  ><li className='clickable' ></li></ListItems>
                <ListItems to='/contact'  ><li className='clickable' ></li></ListItems>
            </ul>
        </MenuWrapper>
    )
}

const MenuWrapper = styled.div`
    position: fixed;
    left: 0px;
    top: 0px;
    height: 100vh;
    display: flex;
    align-items: center;
    z-index: 1000;

    ul{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-left: 2rem;
    }

    @media only screen and (max-width: 500px){
        position: fixed;
        left: unset;
        top: unset;
        bottom: 0;
        height: unset;
        width: 100vw;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        z-index: 1000;

        ul{
            display: flex;
            flex-direction: row;
            align-items: flex-end;
            justify-content: center;
            margin: 0;
            margin-bottom: 2rem;
        }
    }

`

const ListItems = styled(NavLink)`
    border-bottom: 3px solid var(--white);
    margin-bottom: 1rem;
    padding: 1rem 0;
    list-style: none;
    width: 2rem;
    transition: all 0.3s ease;

    &.active{
        width: 4rem;
    }

    @media only screen and (max-width: 500px){
        
        border: unset;
        width: 0px;
        height: 1.2rem;
        border-right: 4px solid var(--white);
        margin: 0;
        margin-right: 2rem;

        &.active{   
            width: 0;
            height: 3.4rem;
        }

    }
        
`

export default Menu;